var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnLeftSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4.9977479 9.0618038",
    style: {
      enableBackground: "new 0 0 4.9977479 9.0618038"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_1_",
    d: "M0.1368138,4.1716185l4.0348115-4.0348115c0.1821241-0.1821243,0.4932303-0.1846155,0.6835775,0.0057318 c0.1847806,0.1847806,0.1929135,0.4963954,0.0057316,0.6835772L1.1560827,4.5309677l3.7048516,3.7048512 C5.0430589,8.417943,5.0455499,8.7290487,4.8552027,8.9193964C4.6704221,9.1041775,4.3588071,9.1123104,4.1716251,8.925128 L0.1368138,4.890317C0.040167,4.7936702-0.0058945,4.6607013,0.0006029,4.5287318 C-0.0049275,4.3995967,0.0396048,4.2688274,0.1368138,4.1716185z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLeftSmall);
export default __webpack_public_path__ + "static/media/BtnLeftSmall.94bd3bbb.svg";
export { ForwardRef as ReactComponent };